import { ISutochnoPilot } from '../../types/sutochnoPilot';

export const DEFAULT_RESPONSE: ISutochnoPilot = {
  isPilotEnabled: false,
  regions: [],
};
